"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var theme_1 = require("../theme");
var react_jss_1 = require("react-jss");
var classnames_1 = __importDefault(require("classnames"));
var Typography_1 = __importDefault(require("../Typography"));
var Icon_1 = __importDefault(require("../Icon"));
var useStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    tag: function (_a) {
        var size = _a.size;
        return ({
            borderRadius: 100,
            color: theme.colors.Grey[900],
            marginRight: 4,
            padding: size === 'regular' ? '6px 12px' : '3px 10px',
            minWidth: 18,
            display: 'inline-flex',
            boxSizing: 'border-box',
            justifyContent: 'space-between',
            alignItems: 'center',
        });
    },
    icon: function (_a) {
        var size = _a.size;
        return ({
            marginLeft: 4,
            marginTop: size === 'regular' ? 2 : 0,
        });
    },
}); });
var defaultProps = {
    size: 'regular',
};
var Tag = function (props) {
    var theme = (0, react_jss_1.useTheme)();
    var onRemove = props.onRemove, label = props.label, className = props.className, id = props.id, color = props.color, style = props.style, size = props.size, rest = __rest(props, ["onRemove", "label", "className", "id", "color", "style", "size"]);
    var styles = useStyles(props);
    var themeColor = (0, react_1.useMemo)(function () {
        return color
            ? (0, theme_1.getThemeColorFromAlias)(color, theme.colors)
            : theme.colors.Grey[100];
    }, [color, theme.colors]);
    return (react_1.default.createElement("span", __assign({ className: (0, classnames_1.default)(styles.tag, className), style: __assign({ background: themeColor }, style) }, rest),
        typeof label === 'string' ? (react_1.default.createElement(Typography_1.default, { variant: size === 'regular' ? 'textMedium' : 'textSmall' }, label)) : (label),
        onRemove && (react_1.default.createElement(Icon_1.default, { name: 'remove', onClick: function (e) { return onRemove(e, id); }, size: 'sm', className: styles.icon }))));
};
Tag.defaultProps = defaultProps;
exports.default = Tag;
//# sourceMappingURL=index.js.map